export const isStorageAvailable = (type) => {
  try {
    const storage = window[type];
    const test = '__storage_test__';
    storage.setItem(test, test);
    storage.removeItem(test);
    return true;
  } catch {
    return false;
  }
};

// Salva tema in entrambi i storage per massima compatibilità
const saveToStorages = (theme) => {
  
  // SessionStorage (priorità per Chrome dopo redirect)
  if (isStorageAvailable('sessionStorage')) {
    sessionStorage.setItem('theme', theme);
  }
  
  // LocalStorage (retrocompatibilità + il tuo codice originale)
  if (isStorageAvailable('localStorage')) {
    localStorage.setItem('theme', theme);
  }
};

// Recupera tema con priorità SOLO se non c'è URL param
const getStoredThemeAsFallback = () => {
  // Priorità: LocalStorage > SessionStorage
  let theme;
  
  if (isStorageAvailable('localStorage')) {
    theme = localStorage.getItem('theme');
    if (theme) {
      return theme;
    }
  }
  if (isStorageAvailable('sessionStorage')) {
    theme = sessionStorage.getItem('theme');
    if (theme) {
      return theme;
    }
  }
  return null;
};

// Funzione principale: URL SEMPRE prioritario
export const determineTheme = (defaultTheme) => {
  const params = new URLSearchParams(window.location.search);
  const urlTheme = params.get("theme");
  
  if (urlTheme) {
    // URL presente: SEMPRE prioritario, sovrascrive tutto
    saveToStorages(urlTheme); // Sincronizza entrambi gli storage
    return urlTheme;
  }
  
  // URL assente: usa storage come fallback
  const storedTheme = getStoredThemeAsFallback();
  if (storedTheme) {
    return storedTheme;
  }
  
  // Ultimo fallback: tema default
  saveToStorages(defaultTheme); // Salva default per prossima volta
  return defaultTheme;
};

// Pulisci entrambi gli storage (utile per debug)
export const clearAllThemeStorage = () => {
  
  // SessionStorage  
  if (isStorageAvailable('sessionStorage')) {
    sessionStorage.removeItem('theme');
  }
  
  // LocalStorage
  if (isStorageAvailable('localStorage')) {
    localStorage.removeItem('theme');
  }
};
